import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { AlertTriangle } from 'lucide-react';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <div className="flex items-center gap-4 mb-8">
            <AlertTriangle className="h-8 w-8 text-accent" />
            <h1 className="font-outfit text-4xl font-semibold tracking-tight" data-testid="disclaimer-title">
              Disclaimer
            </h1>
          </div>
          
          <div className="prose prose-invert max-w-none space-y-8 text-muted-foreground">
            <div className="glass border border-accent/50 rounded-xl p-6 mb-8">
              <p className="text-foreground font-medium text-lg">
                ShipTesla is NOT affiliated with, endorsed by, or sponsored by Tesla, Inc.
              </p>
            </div>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Trademark Notice</h2>
              <p>
                Tesla, Model S, Model 3, Model X, Model Y, Cybertruck, and other Tesla product 
                names are trademarks or registered trademarks of Tesla, Inc. in the United States 
                and other countries.
              </p>
              <p className="mt-4">
                ShipTesla is an independent vehicle transport service provider that specializes 
                in shipping Tesla vehicles. Our use of the Tesla name is solely for the purpose 
                of identifying the types of vehicles we transport and does not imply any 
                affiliation, endorsement, or sponsorship by Tesla, Inc.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Service Disclaimer</h2>
              <p>
                ShipTesla operates as a vehicle transport broker, not a carrier. We connect 
                customers with licensed and insured auto transport carriers. While we carefully 
                vet all carriers in our network:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>ShipTesla does not physically transport vehicles</li>
                <li>Carrier performance may vary</li>
                <li>Delivery times are estimates, not guarantees</li>
                <li>Exact pickup or delivery times cannot be guaranteed</li>
                <li>Claims for damage should be filed with the carrier's insurance</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Deposit Policy</h2>
              <p>
                Deposit is fully refundable until dispatch confirmation. After a carrier has been 
                assigned and confirmed for your transport, the deposit becomes non-refundable.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Pricing Disclaimer</h2>
              <p>
                All quotes provided are estimates based on current market conditions at the time 
                of quote generation. Final pricing may vary based on:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Fuel prices at time of transport</li>
                <li>Carrier availability</li>
                <li>Route conditions and accessibility</li>
                <li>Seasonal demand fluctuations</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Limitation of Liability</h2>
              <p>
                ShipTesla's liability is limited to the deposit amount paid. We are not 
                responsible for:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Damage occurring during transport (carrier's insurance applies)</li>
                <li>Delays caused by weather, traffic, or carrier issues</li>
                <li>Personal items left in vehicles</li>
                <li>Indirect or consequential damages</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">Contact</h2>
              <p>
                For questions about this disclaimer or our services, please contact us at 
                legal@shiptesla.com.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
